// src/components/side-menu/ResponsivePrimaryNav.jsx
import { Link, useLocation } from "react-router-dom";

function NavItem({ to, customIcon, label, active, variant, hideLabelMobile }) {
  const iconColor = active ? "text-[#ea4d3d]" : "text-white";

  if (variant === "bar") {
    // mobile bottom bar
    return (
      <Link
        to={to}
        aria-current={active ? "page" : undefined}
        aria-label={label}
        className={[
          "no-underline flex flex-col items-center justify-center gap-[5px]",
          "rounded-[12px] py-1.5 min-w-0 transition-colors duration-150",
          hideLabelMobile ? "flex-none px-3" : "flex-1 px-1",
        ].join(" ")}
      >
        <span className={["grid place-items-center leading-none", iconColor].join(" ")}>
          {customIcon}
        </span>
        {!hideLabelMobile && (
          <span
            className={[
              "text-[12px] font-medium leading-none max-w-full truncate",
              active ? "text-[#ea4d3d]" : "text-white",
            ].join(" ")}
          >
            {label}
          </span>
        )}
      </Link>
    );
  }

  // desktop sidebar
  return (
    <Link
      to={to}
      aria-current={active ? "page" : undefined}
      aria-label={label}
      className={[
        "no-underline flex flex-col items-center justify-center gap-1.5 text-center",
        "rounded-[14px] px-1.5 pt-3.5 pb-3 transition-colors duration-150",
        active ? "bg-[#1d1d27]" : "bg-transparent hover:bg-white/[0.04]",
      ].join(" ")}
    >
      <span
        className={["grid place-items-center leading-none", iconColor].join(" ")}
        style={{ width: 28, height: 28 }}
      >
        {customIcon}
      </span>
      <span className="text-[13px] font-medium tracking-[0.01em] text-white">{label}</span>
    </Link>
  );
}

export default function ResponsivePrimaryNav({ items = [] }) {
  const { pathname } = useLocation();

  const isActive = (item) => {
    const mainMatch = pathname === item.to || pathname.startsWith(item.to + "/") || pathname.startsWith(item.to);
    if (mainMatch) return true;
    if (Array.isArray(item.alias)) {
      return item.alias.some(alias => pathname === alias || pathname.startsWith(alias + "/") || pathname.startsWith(alias));
    }
    return false;
  };

  return (
    <>
      {/* mobile: fixed bottom bar (< 880px) */}
      <div
        className={[
          "block min-[880px]:hidden",
          "fixed bottom-0 left-0 w-full",
          "bg-[#0f0f17] border-t border-white/[0.08]",
          "z-[100] pointer-events-auto",
        ].join(" ")}
        style={{ paddingTop: 8, paddingBottom: "calc(env(safe-area-inset-bottom,0px) + 8px)" }}
      >
        <nav className="mx-auto w-full max-w-[480px] flex justify-between items-center gap-1 px-1.5 min-h-[64px]">
          {items.map((it) => (
            <NavItem key={it.to} {...it} active={isActive(it)} variant="bar" />
          ))}
        </nav>
      </div>

      {/* desktop: fixed left sidebar (>= 880px) */}
      <aside className="hidden min-[880px]:flex min-[880px]:fixed min-[880px]:left-0 min-[880px]:top-0 min-[880px]:h-screen min-[880px]:w-24 min-[880px]:flex-col min-[880px]:items-stretch min-[880px]:gap-1.5 min-[880px]:bg-[#0f0f17] min-[880px]:pt-[22px] min-[880px]:px-2.5 min-[880px]:z-[9998] min-[880px]:border-r min-[880px]:border-white/[0.06]">
        {items.map((it) => (
          <NavItem key={it.to} {...it} active={isActive(it)} variant="sidebar" />
        ))}
      </aside>

      <div className="hidden min-[880px]:block min-[880px]:ml-24" />
    </>
  );
}
